import { Box, List, Stack, Typography, Button } from "@mui/material";
import { FC, useState } from "react";
import { User } from "types/user";
import { UserItem } from "./UserItem";
import dayjs from "dayjs";
import { ExpandLess, ExpandMore } from "@mui/icons-material";

export const GraduationClassItem: FC<{ graduationClass: any }> = ({
  graduationClass,
}) => {
  const [showStudents, setShowStudents] = useState(false);

  return (
    <Box ml={2}>
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        mb={1}
      >
        <Box>
          <Typography variant="h6" fontWeight={400}>
            {graduationClass.name}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <strong>Start Date:</strong>{" "}
            {dayjs(graduationClass.start_date).format("ll")}
          </Typography>
        </Box>
        <Box>
          <Button
            variant={"outlined"}
            color="primary"
            size="small"
            onClick={() => setShowStudents(!showStudents)}
            startIcon={showStudents ? <ExpandLess /> : <ExpandMore />}
          >
            {showStudents ? "Hide Students" : "Display Students"}
          </Button>
        </Box>
      </Stack>
      {showStudents && (
        <Box mt={1} ml={2}>
          <Typography variant="body1" fontWeight={600} fontSize={18}>
            Students:
          </Typography>
          <List>
            {graduationClass.students.map((student: User) => (
              <UserItem key={student.user_id} user={student} />
            ))}
          </List>
        </Box>
      )}
    </Box>
  );
};
